<template>
  <el-dialog title="服务协议" :visible.sync="$store.state.isShowServiceAgreement" width="40%" :show-close="false"
    :close-on-press-escape="false" :close-on-click-modal="false">
    <span class="popup-content">在您注册成为商城用户的过程中，您需要完成我们的注册流程并通过点击同意的形式在线签署以下协议，请您务必仔细阅读、充分理解协议中的条款内容后再点击同意。
      <br>【请您注意】如果您不同意上述协议或其中任何条款约定，请您停止注册。您停止注册后将仅可以浏览我们的商品信息但无法享受我们的产品或服务。如您按照注册流程提示填写信息、阅读并点击同意上述协议且完成全部注册流程后，即表示您已充分阅读、理解并接受协议的全部内容：并表明您也同意我们可以依据以上的隐私政策内容来处理您的个人信息。
      <br>如您对以上协议内容有任何疑问，您可随时与我们联系。
      <br>点击同意即表示您已阅读并同意<a @click="openAgreementDetail">《服务协议》</a>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="refuseHandler">不同意</el-button>
      <el-button type="primary" @click="agreeHandler">同意</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { GET_SERVICE_AGREEMENT_STATUS } from '@/store/types'

import { updateServiceAgreement } from '@/services/api.index'

export default {
  methods: {
    refuseHandler() {
      localStorage.clear()
      this.$store.commit(GET_SERVICE_AGREEMENT_STATUS, { status: false })
      window.location.href = process.env.SHOP_URL + 'member/logout'
    },
    async agreeHandler() {
      // 接口
      await updateServiceAgreement()
      this.$store.commit(GET_SERVICE_AGREEMENT_STATUS, { status: false })
    },
    openAgreementDetail() {
      window.open(process.env.SHOP_URL + '/article/detail/14_0')
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-content {
  line-height: 1.8;
}

@media screen and (min-width: 220px) and (max-width:600px) {
  /deep/ .el-dialog{
    width: 90% !important;
  }
}


</style>


// WEBPACK FOOTER //
// src/components/PopupServerAgreement.vue